/* eslint-disable max-len */
import styled from 'styled-components'
import { number, string } from 'prop-types'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const Svg = styled.svg`
  .a {
    fill: none;
    stroke: ${prop('color', colorsOptions.greys['grey-100'])};
  }
`
function SortIcon({ color, hoverColor, size, ...props }) {
  return (
    <Svg
      viewBox="0 0 40 40"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
    >
      <g transform="translate(1 -15)">
        <g transform="translate(11 28)">
          <g transform="translate(0 2.133)">
            <line
              className="a"
              x2="8.32"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
          <g transform="translate(0 7.2)">
            <line
              className="a"
              x2="2.347"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
          <g transform="translate(0 12.24)">
            <line
              className="a"
              x2="9.493"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
          <circle
            className="a"
            cx="2.133"
            cy="2.133"
            r="2.133"
            transform="translate(8.853)"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <circle
            className="a"
            cx="2.133"
            cy="2.133"
            r="2.133"
            transform="translate(2.88 5.067)"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <circle
            className="a"
            cx="2.133"
            cy="2.133"
            r="2.133"
            transform="translate(10.027 10.107)"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <g transform="translate(13.653 2.133)">
            <line
              className="a"
              x2="2.347"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
          <g transform="translate(7.68 7.2)">
            <line
              className="a"
              x2="8.32"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
          <g transform="translate(14.826 12.24)">
            <line
              className="a"
              x2="1.173"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
        </g>
      </g>
    </Svg>
  )
}

SortIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number,
}

export default SortIcon
